<template>
  <div class="page-container">
    <div class="section-top">
      <div class="title-holder">
        <a
          v-bind:href="
            '#/CatalogDetail/' +
              this.$route.params['idCategory'] +
              '/' +
              this.$route.params['idProduct']
          "
          class="link-back"
        >
          <i class="icon icon-arrow-back"></i>
        </a>
        <h1 class="title">
          <span class="title-item">{{
            $ml.with("VueJS").get("techRequest")
          }}</span>
        </h1>
      </div>
    </div>
    <div class="section-main">
      <div class="form-holder">
        <!--        <form @submit.prevent="$modal.show('send-request-equipment')" id="order-form">-->
        <form @submit.prevent="sendApiForm()" id="order-form">
          <div
            class="form-group"
            v-bind:class="{ 'form-group-error': $v.userName.$error }"
          >
            <input
              id="user_name"
              name="user_name"
              type="text"
              v-model="userName"
              @input="$v.userName.$touch()"
              @blur="$v.userName.$touch()"
              class="input"
              v-bind:class="{ 'has-value': $v.userName.$model }"
            />
            <label for="user_name" class="label">{{
              $ml.with("VueJS").get("labelContactPerson")
            }}</label>
            <span
              class="icon icon-error"
              aria-label="icon error"
              v-if="$v.userName.$error"
            ></span>
            <div class="error" v-if="$v.userName.$error">
              {{ $ml.with("VueJS").get("setContactPerson") }}
            </div>
          </div>
          <div
            class="form-group"
            v-bind:class="{ 'form-group-error': $v.userPhone.$error }"
          >
            <the-mask
              mask="+38 (0##) ###-##-##"
              id="user_phone"
              name="user_phone"
              type="tel"
              v-model="userPhone"
              @input="$v.userPhone.$touch()"
              @blur.native="$v.userPhone.$touch()"
              class="input"
              v-bind:class="{ 'has-value': $v.userPhone.$model }"
            />
            <label for="user_phone" class="label">{{
              $ml.with("VueJS").get("labelPhone")
            }}</label>
            <span
              class="icon icon-error"
              aria-label="icon error"
              v-if="$v.userPhone.$error"
            ></span>
            <div class="error" v-if="$v.userPhone.$error">
              {{ $ml.with("VueJS").get("setPhone") }}
            </div>
          </div>
          <div
            class="form-group"
            v-bind:class="{ 'form-group-error': $v.userRegion.$error }"
          >
            <v-select
              id="user_region"
              name="user_region"
              class="select"
              label="name"
              :options="regions"
              :searchable="false"
              :clearable="false"
              :components="{ OpenIndicator }"
              v-model="userRegion"
              @input="$v.userRegion.$touch()"
              @blur="$v.userRegion.$touch()"
              v-bind:class="{ 'has-value': $v.userRegion.$model }"
              :reduce="region => region.name"
            ></v-select>
            <label for="user_region" class="label">{{
              $ml.with("VueJS").get("labelRegion")
            }}</label>
            <span
              class="icon icon-error"
              aria-label="icon error"
              v-if="$v.userRegion.$error"
            ></span>
            <div class="error" v-if="$v.userRegion.$error">
              {{ $ml.with("VueJS").get("setRegion") }}
            </div>
          </div>
          <div
            v-if="submitStatus === 'error'"
            class="error lead-submit-error"
            role="alert"
          >
            {{ $ml.with("VueJS").get(submitErrorKey) }}
          </div>
        </form>
      </div>
    </div>
    <!--    <Modal />-->
    <ModalSuccess />
    <ModalSuccess
      modal-name="pending-request-equipment"
      title-key="msgPendingTitle"
      text-key="msgPendingText"
    />
    <div class="section-bottom">
      <button
        v-if="!requiresNewRequest"
        type="submit"
        form="order-form"
        class="btn btn-full-width btn-main"
        :disabled="isSubmitting || isRegionLoading || regions.length === 0"
      >
        {{ $ml.with("VueJS").get(isSubmitting ? "sending" : "send") }}
      </button>
      <button
        v-else
        type="button"
        class="btn btn-full-width btn-main"
        :disabled="isSubmitting || isRegionLoading || regions.length === 0"
        @click="sendNewApiForm()"
      >
        {{ $ml.with("VueJS").get("leadNewRequestAction") }}
      </button>
    </div>

    <!--    <modal name="send-request-equipment" adaptive="true" resizable="true" height="auto">-->
    <!--      <h3>Отправить заявку на покупку трактора?</h3>-->
    <!--      <div class="modal-buttons">-->
    <!--        <button @click="$modal.hide('send-request-equipment')" class="btn btn-main asdasd">Отправить</button>-->
    <!--        <button @click="$modal.hide('send-request-equipment')" class="btn btn-link">Отменить</button>-->
    <!--      </div>-->
    <!--    </modal>-->
  </div>
</template>

<script>
import { required, helpers } from 'vuelidate/dist/validators.min'
import 'vue-select/dist/vue-select.css'
// import ModalSendRequestEquipment from '../modal/ModalSendRequestEquipment'
import ModalSuccess from '../modal/ModalSuccessForm'
import { TheMask } from 'vue-the-mask'
import { GET_REGIONS, NFM_PRODUCT_ORDERS } from '../../helpers/requests'
import nfmLeadRequest from '../../helpers/nfmLeadRequest'
const phone = helpers.regex('phone', /^[0-9]{9}$/)

export default {
  components: {
    TheMask,
    // Modal: ModalSendRequestEquipment,
    ModalSuccess: ModalSuccess
  },
  data () {
    return {
      title: 'Заявка на технику',
      userName: null,
      userFarm: null,
      userPhone: null,
      userRegion: null,
      submitStatus: null,
      submitErrorKey: 'leadErrorText',
      isSubmitting: false,
      isRegionLoading: false,
      requestId: null,
      requiresNewRequest: false,
      regions: [],
      OpenIndicator: {
        render: createElement => createElement('span')
      },
      category: {}
    }
  },
  validations: {
    userName: {
      required
    },
    userRegion: {
      required
    },
    userPhone: {
      required,
      phone
    }
  },
  mounted () {
    nfmLeadRequest.restoreRequestState(this, window.sessionStorage)
    this.saveLocalStorage()
    this.loadJsonCategories()
    this.loadRegions()
  },
  watch: {},
  methods: {
    async sendApiForm () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.submitStatus = 'error'
        this.submitErrorKey = 'leadErrorText'
        window.scrollTo(0, 0)
        return
      }

      this.submitStatus = null
      const result = await nfmLeadRequest.submitNfmLead(
        this,
        {
          productId: this.$route.params['idProduct'],
          firstname: this.userName,
          phone: this.userPhone,
          region: this.userRegion,
          farm: this.userFarm
        },
        {
          storage: window.sessionStorage,
          cryptoObject: window.crypto,
          send: body => NFM_PRODUCT_ORDERS({
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            body,
            redirect: 'follow'
          }),
          timeoutMs: 15000
        }
      )

      if (result.status === 'busy') {
        return
      }

      if (result.status === 'accepted') {
        this.submitStatus = 'accepted'
        this.$modal.show('success-request-equipment')
        return
      }

      if (result.status === 'pending') {
        this.submitStatus = 'pending'
        this.$modal.show('pending-request-equipment')
        return
      }

      this.submitStatus = 'error'
      this.submitErrorKey = result.errorCode === 'request_conflict' ||
        result.status === 'new_request_required'
        ? 'leadConflictText'
        : (result.status === 'timeout' ||
          result.status === 'transport_error' ||
          result.status === 'invalid_response'
          ? 'leadRetryText'
          : 'leadErrorText')
      window.scrollTo(0, 0)
    },
    async sendNewApiForm () {
      const requestId = nfmLeadRequest.startNewRequest(
        this,
        window.sessionStorage,
        window.crypto
      )

      if (requestId) {
        await this.sendApiForm()
      }
    },
    loadJsonCategories () {
      this.categoriesJson
        .get()
        .then(response => response.json())
        .then(response => {
          this.category = response
        })
    },
    async loadRegions () {
      this.isRegionLoading = true

      try {
        const response = await GET_REGIONS()
        const result = await response.json()

        if (!response.ok || !Array.isArray(result)) {
          throw new Error('invalid_regions')
        }

        this.regions = result.filter(region => region &&
          Number.isInteger(Number(region.id)) &&
          Number(region.id) > 0 &&
          typeof region.name === 'string' &&
          region.name.trim().length > 0
        ).map(region => ({
          id: Number(region.id),
          name: region.name.trim()
        }))

        if (!this.regions.length) {
          throw new Error('empty_regions')
        }

        if (this.userRegion && !this.regions.some(region => region.name === this.userRegion)) {
          this.userRegion = null
        }
      } catch (error) {
        this.regions = []
        this.userRegion = null
        this.submitStatus = 'error'
        this.submitErrorKey = 'leadRegionsErrorText'
      } finally {
        this.isRegionLoading = false
      }
    },
    saveLocalStorage () {
      const prefill = nfmLeadRequest.getAuthenticatedPrefill(window.localStorage)
      this.userName = prefill.userName
      this.userFarm = prefill.userFarm
      this.userPhone = prefill.userPhone
      this.userRegion = prefill.userRegion
    }
  },
  created () {
    this.categoriesJson = this.$resource(
      'categories/' + this.$route.params['idCategory']
    )
  }
}
</script>
